/* eslint-env browser */
import React from 'react';
import PropTypes from 'prop-types';
import { sortAlphaObj } from '../../lib/helpers';

class DataBoxAlphabetComponent extends React.Component {
  constructor(props) {
    super(props);
    this.letters = ['...', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'æ', 'ø', 'å'];
    this.state = {
      letterIndex: this.letters.indexOf(props.initLetter.toLowerCase()),
    };
  }

  render() {
    const { letterIndex } = this.state;
    const { linkColor, rememberState, boxID } = this.props;
    const renderLetters = this.letters.map((l, i) => {
      const { items } = this.props;
      const available = i === 0
      || items.filter((x) => x.name.toLowerCase().indexOf(l) === 0).length > 0;

      let classNames = '';
      if (available) {
        classNames += 'available';
      }

      if (i === letterIndex) {
        classNames += ' active';
      }

      let style = {};
      if (available) {
        if (letterIndex === i) {
          style = { backgroundColor: '#fff', color: linkColor };
        } else {
          style = { backgroundColor: linkColor };
        }
      }

      return (
        <li
          key={l}
          className={classNames}
        >
          <button
            type="button"
            style={style}
            onClick={() => {
              if (available) {
                this.setState({
                  letterIndex: i,
                });
                if (rememberState) {
                  sessionStorage.setItem(`box-alphabet-${boxID}`, this.letters[i]);
                }
              }
            }}
          >
            {l}
          </button>
        </li>
      );
    });

    let { items } = this.props;
    if (letterIndex !== 0) {
      items = items.filter((x) => x.name.toLowerCase().indexOf(this.letters[letterIndex]) === 0);
    }

    const renderItems = items.sort(sortAlphaObj).map((item) => {
      const renderChildren = item.children.map((c) => (
        <li key={c.id}>
          <a href={c.url}>
            {c.name}
          </a>
        </li>
      ));

      if (item.children.length > 0) {
        return (
          <li key={item.id}>
            {(() => {
              if (!item.url) {
                return (
                  <span>
                    {item.name}
                  </span>
                );
              }

              return (
                <a href={item.url}>
                  {item.name}
                </a>
              );
            })()}
            <ul>
              {renderChildren}
            </ul>
          </li>
        );
      }

      if (!item.parent) {
        return (
          <li key={item.id}>
            <a href={item.url}>
              {item.name}
            </a>
          </li>
        );
      }

      return null;
    });

    return (
      <div>
        <ul className="letters">
          {renderLetters}
        </ul>
        <ul>
          {renderItems}
        </ul>
      </div>
    );
  }
}

DataBoxAlphabetComponent.defaultProps = {

};

DataBoxAlphabetComponent.propTypes = {
  initLetter: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  linkColor: PropTypes.string.isRequired,
  rememberState: PropTypes.bool.isRequired,
  boxID: PropTypes.number.isRequired,
};

DataBoxAlphabetComponent.displayName = 'DataBoxAlphabetComponent';
export default DataBoxAlphabetComponent;
